import styled from 'styled-components'
import { customTheme } from '../../../styles/theme'
interface IConfigDefault {
  color: string;
}

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 9999;

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(35, 35, 35, .8);
`

export const Card = styled.div<IConfigDefault>`
  width: 597px;
  margin-top: 50px;
  padding-top: 100px;
  padding-bottom: 34px;

  position: relative;

  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  background: rgba(255, 255, 255, 0.2);
  border: 1.84534px solid ${({ color }) => color};
  box-shadow: 0px 7.23636px 35.2773px rgba(0, 0, 0, 0.18);
  backdrop-filter: blur(54.4375px);
  border-radius: 33px;
  max-width: 90vw;

  button {
    max-width: 90%;
    margin: auto;
  }
`

export const EllipseWrapper = styled.div`
  position: absolute;
  top: -68px;
`

export const Title = styled.h4<IConfigDefault>`
  font-weight: bold;
  font-size: 32px;
  line-height: 1.2;
  text-align: center;
  margin-bottom: 10px;
  
  color: ${({ color }) => color || '#fff'};

  @media (max-width: ${customTheme.breakpoints[1]}) {
    font-size: 28px;
  }
`

export const Description = styled.p<IConfigDefault>`
  max-width: 80%;
  text-align: center;

  font-size: 24px;
  line-height: 48px;
  color: ${({ color }) => color || '#fff'};

  @media (max-width: ${customTheme.breakpoints[1]}) {
    line-height: 32px;
    font-size: 18px;
  }
`

export const ContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  max-width: 90%;
  max-height: 45vh;
  margin-bottom: 20px;

  overflow: auto;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  
  & {
    scrollbar-width: thin;
    scrollbar-color: #fff rgba(255,255,255, .19);
  }

  &::-webkit-scrollbar {
    width: 12px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255,255,255, .19);
  }

  &::-webkit-scrollbar-thumb {
    background-color: #fff;
    border-radius: 20px;
    border: 3px solid rgba(255,255,255, .19);
  }
`
